<script>
    import { Bar, mixins } from 'vue-chartjs';

    export default {
        extends: Bar,
        mixins: [mixins.reactiveProp],
        props: {
            chartData: {
                required: true,
                type: [Object, Array],
            },
            options: {
                type: Object,
            },
        },
        mounted() {
            this.chartRender();
        },
        methods: {
            chartRender() {
                this.renderChart(this.chartData, this.options, { responsive: true });
            },
        },
    };
</script>
